module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=NC - New Caledonia.5e59d165.svg";